export default __webpack_public_path__ + "static/media/opencollective.e4e08ecc.svg";